// Binnen de Discord-iframe geldt een strikte CSP. Al het netwerkverkeer moet
// via het /.proxy voorvoegsel lopen, inclusief websockets. Discord haalt dat
// voorvoegsel er zelf weer af en stuurt het door naar de URL die in het
// Developer Portal onder URL Mappings staat.
//
// Alles wat het netwerk op gaat hoort dus via apiUrl() of wsUrl() te gaan,
// nooit via een handgeschreven pad.

export const PROXY_PREFIX = '/.proxy'

function join(path: string): string {
  return path.startsWith('/') ? path : `/${path}`
}

/** Bijvoorbeeld: apiUrl('/token') -> '/.proxy/api/token' */
export function apiUrl(path: string): string {
  return `${PROXY_PREFIX}/api${join(path)}`
}

/** Bijvoorbeeld: wsUrl('/ws', { instance_id: 'abc' }) -> 'wss://host/.proxy/api/ws?instance_id=abc' */
export function wsUrl(path: string, params: Record<string, string> = {}): string {
  const scheme = location.protocol === 'https:' ? 'wss:' : 'ws:'
  const url = new URL(`${scheme}//${location.host}${apiUrl(path)}`)
  for (const [key, value] of Object.entries(params)) {
    url.searchParams.set(key, value)
  }
  return url.toString()
}

export class ApiError extends Error {
  constructor(
    message: string,
    readonly status: number,
  ) {
    super(message)
    this.name = 'ApiError'
  }
}

export async function postJson<T>(path: string, body: unknown): Promise<T> {
  const response = await fetch(apiUrl(path), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  })

  if (!response.ok) {
    const text = await response.text().catch(() => '')
    throw new ApiError(`${path} gaf ${response.status}: ${text.slice(0, 300)}`, response.status)
  }

  return (await response.json()) as T
}
